function isIE () {
	var myNav = navigator.userAgent.toLowerCase();
	return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
}
if (isIE () && isIE () < 9) {
	var no_support_page = 'browser-not-supported';
	if (window.location.href.indexOf("browser-not-supported") == -1) {
		window.location = '/'+no_support_page;
	}
	
} 


jQuery( document ).ready(function($) {


	//---------------------------
	// Color menu if its current page
	//---------------------------
	$('header .main_menu a').each(function(){
		var $select = $(this);
		if ( window.location.href.indexOf($select.attr('href')) > -1 ){$select.addClass('active');}
	});

	//---------------------------
	//Fixed header 
	//---------------------------
	var $header = $("header");
	var $body = $("body");
	var $content = $("#content");
	var header_height = $header.height() ;
	  

	var isShowing = false;
	$(window).scroll(function(e) {
		console.log('scroll:'+$(this).scrollTop());
		if ($(this).scrollTop() > header_height ) {
			$header.addClass('fixed');
			$body.css('padding-top', header_height );
			console.log('fixed');
			
			//animation
			if (isShowing == false){
				isShowing = true;
				//$header.css('margin-top', '-'+header_height );
				$header.css('margin-top', '-'+$("header").height()+'px' );
				$header.stop().animate({ marginTop: '0' }, 300);
			}

		} else {
			console.log('NOTfixed');
			$header.removeClass('fixed');
			$body.css('padding-top', '0' );
			$header.stop().css('margin-top', '0' );
			isShowing = false;

			
		}
	});


	//------------------------------
	// Menu icon
	//------------------------------
	var menuicon = $(".menuicon");
	menuicon.click(function() {
		if(menuicon.hasClass('active'))
		{
			$(this).removeClass('active');
			$(this).children().each(function() {
			$(this).removeClass('active');
			$(".nav_wrapper").removeClass('active');
		});
		}
		else
		{
			$(this).addClass('active');
			$(this).children().each(function() {
				$(this).addClass('active');
			});
			$(".nav_wrapper").addClass("active");
		}
	});
	

	//----------------------------------
	// homepage_images_section
	//----------------------------------
	/*var circle = $(".circle");
	circle.click(function(e) {
		e.preventDefault();
		var image_caption = $(this).parent().prev();
		var plus = $(this).children(".plus");
		if(image_caption.hasClass('active'))
		{
			image_caption.removeClass("active");
			plus.show();
		}
		else
		{
			image_caption.addClass("active");
			plus.hide();

		}
	});*/
	/*var imgblock = $(".homepage_image");
	imgblock.hover(function() {
		$(this).find(".image_caption").addClass("active");
		$(this).find(".plus").hide();
	}, function() {
		$(this).find(".image_caption").removeClass("active");
		$(this).find(".plus").show();
	});*/

	//------------------------------------
	// News-items
	//------------------------------------
	
	$("div.news_item_wrapper").on("mouseenter", "div.feature_image",
		function() {
			var $news_excerpt = $(this).find(".news_excerpt");
			var top_value = "-=218px";
			if($(window).width() <= 500)
			{
				var top_value = "-=160px";
			}

			$news_excerpt.animate({
				top: top_value,
			}, 600, function() {
			});
			var $news_title = $(this).find(".news_title");
			$news_title.css('padding-bottom', '20px');
			
		});
	$("div.news_item_wrapper").on("mouseleave", "div.feature_image",
		function() {
			var $news_excerpt = $(this).find(".news_excerpt");
			var top_value = "+=218px";
			if($(window).width() <= 500)
			{
				var top_value = "+=160px";
			}
			$news_excerpt.animate({
				top: top_value,
			}, 600, function() {
				var $news_title = $(this).find(".news_title");
				$news_title.css('padding-bottom', '46px');
					
			});
		
		});
	//---------------------------------
	// pdf icon
	//---------------------------------
	var pdficon = $(".fa-file-pdf-o");
	pdficon.removeClass("fa-file-pdf-o");
	pdficon.addClass("obicon-pdf");





	
});
